<template>
  <div class="home-index">
    <div class="top-info-box">
      <div class="home-block company-info">
        <p class="company-name">{{ companyName }}</p>
        <div class="certification-status">
          <div class="certification-tag" :class="authInfos[authStatus].tagClass"><span>{{ authInfos[authStatus].tag }}</span></div>
          <router-link to="/info/select" class="go-btn" clstag="pageclick|keycount|home|overview_authenticate">
            {{ authInfos[authStatus].btnText }} <i class="iconfont icon-arrow-icon arrow-icon"></i>
          </router-link>
        </div>
        <div class="company-overview">
          <router-link :to="{ name: 'shopList' }" tag="div" class="overview-info" clstag="pageclick|keycount|home|overview_shop_num">
            <p class="overview-title">
              资产数量
              <el-tooltip content="当前显示已授权状态下的资产数量" placement="top-start">
                <i class="el-icon-question-outline info-tip"></i>
              </el-tooltip>
            </p>
            <p class="overview-num">{{ shopNum }}</p>
          </router-link>
          <div class="overview-line"></div>
          <router-link :to="{ name: 'staffList' }" tag="div" class="overview-info" clstag="pageclick|keycount|home|overview_staff_num">
            <p class="overview-title">
              员工数量
              <el-tooltip content="当前显示已激活和未激活状态下的员工数量" placement="top-start">
                <i class="el-icon-question-outline info-tip"></i>
              </el-tooltip>
            </p>
            <p class="overview-num">{{ staffNum }}</p>
          </router-link>
        </div>
      </div>
      <div class="banner-box">
        <p class="banner-msg">咚咚群：<span>1022075109</span></p>
      </div>
    </div>
    <!--店铺数据查看-->
    <ShopData />
    <!-- 店铺管理 -->
    <ShopManage />
    <!-- 新手任务 -->
    <Task />

    <!-- <div class="troduce-box">
      <div class="base-troduce">
        <p class="base-title">什么是企业工作台</p>
        <p class="base-desc">企业工作台是为企业提供的一套完整的资产（店铺）管理、企业员工管理、企业主体信息管理的系统</p>
        <div class="base-img"></div>
      </div>
      <div class="base-troduce do-troduce">
        <p class="base-title">企业工作台能做什么</p>
        <div class="do-troduce-list">
          <div class="detail-box">
            <p class="detail-title"><span>1</span>多类型店铺管理</p>
            <p class="detail-desc">企业管理员可以通过工作台，以企业的维度查看管理该企业开通的多家不同类型的店铺</p>
          </div>
          <div class="detail-box icon2">
            <p class="detail-title"><span>2</span>实现跨店铺管理</p>
            <p class="detail-desc">企业管理员可以通过企业员工的创建，绑定相应的店铺账号，实现跨店铺管理，引入代运营理念</p>
          </div>
          <div class="detail-box icon3">
            <p class="detail-title"><span>3</span>主体信息修改</p>
            <p class="detail-desc">企业管理员可通过企业工作台申请修改主体信息</p>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { tenantStats } from '@/api/apis/common';
import ShopManage from './components/shopManage.vue';
import Task from './components/task.vue';
import ShopData from './components/shopData.vue';

export default {
  name: 'Home',
  components: {
    ShopManage,
    ShopData,
    Task,
  },
  data() {
    return {
      shopNum: 0,
      staffNum: 0,
      authInfos: {
        1: {
          btnText: '去认证',
          tag: '待认证',
          tagClass: 'gray',
          desc: '您公司主体信息未认证，暂无法使用系统其他功能',
        },
        2: {
          btnText: '去查看',
          tag: '审核中',
          tagClass: 'yellow',
          desc: '您公司主体信息正在审核中，暂无法使用系统其他功能',
        },
        3: {
          btnText: '去查看',
          tag: '已认证',
          tagClass: 'blue',
          desc: '您公司主体信息已认证通过',
        },
        4: {
          btnText: '去修改',
          tag: '未通过',
          tagClass: 'red',
          desc: '您公司主体信息被驳回，请修改后及时提交审核',
        },
      },
    };
  },
  computed: {
    companyName() {
      return this.$store.state.companyName;
    },
    authStatus() {
      return this.$store.state.authStatus;
    },
  },
  created() {
    this.getOverviewInfo();
  },
  methods: {
    // 查询基础信息
    async getOverviewInfo() {
      const res = await tenantStats({});
      const {
        // eslint-disable-next-line no-unused-vars
        code, data, message, subErrors,
      } = res;
      this.loading = false;
      if (code === 200) {
        this.shopNum = data.assetCount;
        this.staffNum = data.employeeCount;
      } else {
        this.$message.error(message || '获取安全认证信息失败');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home-index {
  .mt20 {
    margin-top: 20px;
  }
  .top-info-box {
    display: flex;
    .company-info {
      padding-bottom: 17px;
      width: 510px;
      height: 168px;

      .company-name {
        font-size: 18px;
        line-height: 18px;
        font-weight: 500;
        color: rgba(0,0,0,1);
      }
      .certification-status {
        margin-top: 6px;
        display: flex;
        .certification-tag {
          padding-left: 2px;
          width: 42px;
          line-height: 16px;
          color: rgba(255,255,255,1);
          border-radius: 6px 2px 6px 2px;
          background-image: linear-gradient(45deg, #808080 0%, #999999 100%);
          box-sizing: border-box;
          span {
            display: block;
            font-size: 12px;
            transform: scale(0.83);
          }
          &.blue {
            background-image: linear-gradient(45deg, #4F7CF8 0%, #668DF8 100%);
          }
        }
        .go-btn {
          margin-left: 15px;
          display: flex;
          font-size: 12px;
          color: #4D80F0;
          line-height: 16px;
          justify-content: center;
          .arrow-icon {
            font-size: 14px;
          }
        }
      }

      .company-overview {
        width: 100%;
        margin-top: 30px;
        display: flex;
        align-items: center;
        .overview-line {
          width: 1px;
          height: 45px;
          background: rgba(0,0,0,0.09);
        }
        .overview-info {
          flex: 1;
          text-align: center;
          box-sizing: border-box;
          cursor: pointer;
          .overview-title {
            margin-bottom: 15px;
            font-size: 14px;
            line-height: 14px;
            color: rgba(89,89,89,1);
            .info-tip {
              color: #9ca7b6;
            }
          }
          .overview-num {
            margin-bottom: 4px;
            font-size: 28px;
            font-family: 'JDZhengHT-Regular';
            line-height: 28px;
            color: rgba(77,128,240,1);
          }
        }
      }
    }

    .banner-box {
      margin-left: 20px;
      padding: 102px 30px 0;
      width: 510px;
      height: 168px;
      border-radius: 4px;
      background-color: #fff;
      background-image: url('../../assets/imgs/home/banner@3x.png');
      background-size: 100%;
      background-repeat: no-repeat;
      box-sizing: border-box;
      .banner-msg {
        font-size: 14px;
        line-height: 20px;
        color: rgba(255,255,255,1);
        span {
          font-family: 'JDZhengHT-Regular';
        }
      }
    }
  }
  .troduce-box {
    margin-top: 20px;
    display: flex;
    .base-troduce:last-child {
      margin-right: 0;
    }
    .base-troduce {
      margin-right: 20px;
      padding: 30px 30px 16px;
      width: 300px;
      height: 281px;
      background: rgba(255,255,255,1);
      border-radius: 4px;
      box-sizing: border-box;
      .base-title {
        margin-bottom: 20px;
        font-size: 16px;
        line-height: 16px;
        font-weight: 500;
        color: rgba(38,38,38,1);
      }
      .base-desc {
        margin-bottom: 24px;
        font-size: 14px;
        color: rgba(140,140,140,1);
      }
      .base-img {
        width: 246px;
        height: 113px;
        background-image: url('../../assets/imgs/home/home-troduce1@2x.png');
        background-size: 100%;
        background-repeat: no-repeat;
      }
    }
    .do-troduce {
      width: 720px;
      padding: 30px 30px 40px;
      overflow: hidden;
      .do-troduce-list {
        width: 100%;
        display: flex;
        .detail-box:last-child {
          margin-right: 0;
        }
      }
      .detail-box {
        margin-right: 20px;
        width: 206px;
        height: 175px;
        background-color: rgba(228,241,255,0.6);
        border-radius: 4px;
        background-image: url("../../assets/imgs/home/home-troduce-icon1@2x.png");
        background-position: 126px 95px;
        background-repeat: no-repeat;
        background-size: 100px 100px;
        &.icon2 {
          background-image: url("../../assets/imgs/home/home-troduce-icon2@2x.png");
        }
        &.icon3 {
          background-image: url("../../assets/imgs/home/home-troduce-icon3@2x.png");
        }

        .detail-title {
          padding: 10px 20px;
          display: flex;
          box-sizing: border-box;
          border-bottom: 1px solid #ffffff;
          font-size: 14px;
          color: rgba(38,38,38,1);
          line-height: 28px;
          span {
            margin-right: 10px;
            width: 28px;
            height: 28px;
            font-size: 12px;
            color: #FFFFFF;
            text-align: center;
            background-image: url('../../assets/imgs/home/home-troduce-num-bg@2x.png');
            background-size: 100%;
          }
        }
        .detail-desc {
          padding: 20px;
          font-size: 14px;
          color: #8C8C8C;
          line-height: 22px;
          box-sizing: border-box;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.home-index {
  .home-block {
    padding: 20px;
    width: 100%;
    background: rgba(255,255,255,1);
    border-radius: 4px;
    box-sizing: border-box;
  }
  .home-block-title-box {
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    line-height: 18px;
    font-weight: 500;
    color: rgba(0,0,0,0.85);
    .more-link {
      font-size: 14px;
      font-weight: normal;
      color: rgba(0,0,0,0.85);
      i {
        position: relative;
        top: 1px;
        color: rgba(0,0,0,0.65);
      }
      &:hover {
        color: #4d80f0;
        i {
          color: #4d80f0;
        }
      }
    }
  }
}
</style>
